import { Textarea } from 'browser/components/atomic-elements/atoms/textarea/textarea'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const TextareaField = LabelFieldFactory({ InputComponent: Textarea })
export { TextareaField }
